//#region Imports

import { Component } from '@angular/core';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { OutsideClick } from "../../directives/outside-click/outside-click.directive";
import { ButtonComponent } from "../../components/button/button.component";
import { ButtonRadiusEnum } from '../../components/button/types/button-radius.enum';
import { ButtonTypeEnum } from '../../components/button/types/button-type.enum';

//#endregion

@Component({
  selector: 'l-modal-status',
  standalone: true,
  imports: [ConfirmDialogModule, OutsideClick, ButtonComponent],
  templateUrl: './modal-status.component.html'
})
export class ModalStatusComponent {

  //#region Public Properties

  public buttonRadiusEnum: typeof ButtonRadiusEnum = ButtonRadiusEnum;

  public buttonTypesEnum: typeof ButtonTypeEnum = ButtonTypeEnum;

  public readonly key = 'status-modal';

  public readonly defaultActionLabel = 'Voltar';

  //#endregion

}
